/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import { login, logout } from '@/api/login';
import { getToken, removeToken, setToken, getOpenid } from '@/utils/cookies';
import Vue from 'vue';
var user = {
  state: {
    token: getToken()
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    }
  },
  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;
      var params = {
        user_name: userInfo.account,
        user_pwd: userInfo.password,
        openid: getOpenid()
      };
      return new Promise(function (resolve, reject) {
        login(params).then(function (response) {
          if (response.token) {
            setToken(response.token);
            commit('SET_TOKEN', response.token);
          } else {
            Vue.$vux.toast.show({
              text: '获取不到登录成功token,请稍后再尝试',
              type: 'warn',
              time: 2 * 1000
            });
          }
          resolve();
        }).catch(function (error) {
          reject(error);
        });
        // })
      });
    },
    // 登出
    LogOut: function LogOut(_ref2) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        logout({}).then(function (res) {
          commit('SET_TOKEN', '');
          removeToken();
          resolve();
        });
      });
    },
    // 设置token
    SetToken: function SetToken(_ref3, token) {
      var commit = _ref3.commit;
      commit('SET_TOKEN', token);
    }
  }
};
export default user;